import { useParams } from "react-router-dom"
import Rolemodels2024 from "./Rolemodels2024/Rolemodels2024"
import Rolemodels2025 from "./Rolemodels2025/Rolemodels2025"
import Rolemodels2026 from "./Rolemodels2026/Rolemodels2026"
import P404 from "../404/404"
import RolemodelCards from "./RolemodelCards/RolemodelCards"
import gsap from "gsap"
import { Flip } from "gsap/Flip"

interface RolemodelProps {
	lang: string
}

const editions = ['2024', '2025', '2026']

const Rolemodels: React.FC<RolemodelProps> = (props: RolemodelProps) => {
	gsap.registerPlugin(Flip)
	const {year} = useParams<string>()
	if (!year || !editions.some((e)=>e===year)) return <P404 lang={props.lang}></P404>
	return(<div className="rolemodels">
		{year==='2024'? <Rolemodels2024 lang={props.lang}></Rolemodels2024>:null}
		{year==='2025'? <Rolemodels2025 lang={props.lang}></Rolemodels2025>:null}
		{year==='2026'? <Rolemodels2026 lang={props.lang}></Rolemodels2026>:null}
		<RolemodelCards year={year} lang={props.lang}></RolemodelCards>
	</div>)
}

export default Rolemodels